<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <div class="row">
            <div class="col-xl-7 col-md-7 col-xs-12 col-sm-12 mt-1">
            </div>
            <div class="col-xl-2 col-md-2 col-xs-12 col-sm-12 offset-xl-3 offset-md-3  mt-1 ">
                <div class="wrapper input-group">

                    <button class="btn btn-light ml-2 " @click="advancedSearch()"><i class="fa fa-align-justify"></i>
                        Busca avançada</button>
                </div>
            </div>
        </div>
        <div class="row mt-3" v-show="advanced_search">
            <div class="col-xl-12 col-md-12 col-xs-12 col-sm-12">
                <fieldset>
                    <div class="row">
                        <div class="col-xl-4 col-md-4 col-xs-12 col-sm-12">
                            <label for="">CPF / CNPJ</label>
                            <input type="text" id="document" class="form-control" placeholder="Ex: xxx.xxx.xxx-xx"
                                v-model="advanced_search_input.document"
                                v-mask="['###.###.###-##', '##.###.###/####-##']">
                        </div>
                        <div class="col-xl-4 col-md-4 col-xs-12 col-sm-12">
                            <label for="">Nome / Razão Social</label>
                            <input type="text" id="description" class="form-control"
                                placeholder="Ex: José Antônio Silva" v-model="advanced_search_input.name">
                        </div>
                        <div class="col-xl-4 col-md-4 col-xs-12 col-sm-12">
                            <label for="">Protocolo</label>
                            <input type="text" id="protocol" class="form-control"
                                placeholder="Ex: ########-######-IRPF-###" v-model="advanced_search_input.protocol"
                                v-mask="['##############-IRPF-###']">
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-xl-12 col-md-12 col-xs-12 col-sm-12">
                            <button class="btn btn-info" @click="executeAdvancedSearch()"> <i
                                    class="fas fa-search fa-sm"></i> Pesquisar</button>
                            <button class="btn btn-danger ml-2" @click="cleanAdvancedSearch()"> <i
                                    class="fas fa-times fa-sm"></i> Limpar</button>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="card shadow mb-4">
                    <!-- Card Header - Dropdown -->
                    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                        <h6 class="m-0 font-weight-bold text-primary">Declarações enviadas
                            <br><small><span v-if="total_itens > 0">Total registros encontrados: {{
                                formatDecimal(total_itens) }}</span></small>
                        </h6> <button class="btn btn-warning btn-sm" @click="loadData()"><i class="fa fa-undo"></i>
                            Recarregar dados</button>
                    </div>
                    <div class="card-body" :class="list_declarations.length <= 0 ? 'card-body-no-spaccing' : ''">
                        <div class="table-responsive">
                            <table class="table" id="dataTable" width="100%" cellspacing="0">
                                <thead>
                                    <tr>
                                        <th>Protocolo</th>
                                        <th>Documento</th>
                                        <th>Nome</th>
                                        <th>Telefone</th>
                                        <th>Valor</th>
                                        <th class="text-center">Status</th>
                                        <th class="text-center">Data envio</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(ir) in list_declarations" :key="ir.id">
                                        <td class="pointer" @click="openDetails(ir)">{{ ir.protocol }} </td>
                                        <td class="pointer" @click="openDetails(ir)">{{ ir.document_formatted }} </td>
                                        <td class="pointer" @click="openDetails(ir)">{{ ir.name }} </td>
                                        <td class="pointer" @click="openDetails(ir)">{{ ir.phone_formatted }} </td>
                                        <td class="pointer" @click="openDetails(ir)">{{ ir.amount_formatted }} </td>
                                        <td class="align-middle text-center"><span class="badge"
                                                :class="badgeStatus(ir.status)">{{ ir.status }}</span></td>
                                        <td class="align-middle text-center">{{ ir.created_at_formatted }} </td>
                                        <td>
                                            <div class="dropdown">
                                                <button class="btn btn-primary dropdown-toggle" type="button"
                                                    id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                                    aria-expanded="false">
                                                    Ações
                                                </button>
                                                <div class="dropdown-menu animated--fade-in"
                                                    aria-labelledby="dropdownMenuButton">
                                                    <button type="button" class="dropdown-item"
                                                        @click="openDetails(ir)">Detalhes</button>
                                                    <button type="button" class="dropdown-item"
                                                        @click="showModalChangeStatus(ir)">Alterar status</button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-if="list_declarations.length > 0 && page > 1">
                                        <td colspan="9" class="align-middle text-center pt-5"> <button
                                                @click="loadData()" class="btn btn-info btn-sm"
                                                :disabled="!buttonPagination"><i class="fa fa-spinner"></i> Carregar
                                                mais registros</button></td>
                                    </tr>
                                    <tr v-show="list_declarations.length <= 0">
                                        <td colspan="9" class="text-center">Nenhum registro encontrado</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div id="modalDisplayChangeStatus" class="modal" :style="{ display: modalDisplayChangeStatus }">
        <div class="row">
            <div class="col-lg-12 col-sm-12 col-xs-12">
                <form @submit="updateStatus">
                <div class="modal-content">
                    <div class="modal-header">
                        Alterar status declaração
                        <button type="button" class="close" @click="closeModalChangeStatus()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-xl-12 col-md-12 col-sm-12">
                                <label for="">Status</label>
                                <select class="form-control" v-model="ir.status">
                                    <option value="" disabled selected>Escolha um status</option>
                                    <option value="Em análise">Em análise</option>
                                    <option value="Em execução">Em execução</option>
                                    <option value="Aguardando pagamento">Aguardando pagamento</option>
                                    <option value="Finalizado">Finalizado</option>
                                    <option value="Em auditoria">Em auditoria</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger" @click="closeModalChangeStatus()"><i
                                class="fa fa-times"></i> Cancelar</button>
                        <button type="submit" class="btn btn-success" :disabled='!validateSpdateStatus'><i
                                class="fa fa-check"></i> Atualizar</button>
                    </div>
                </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { mask } from 'vue-the-mask'

export default {
    directives: { mask },
    components: {
        Loading
    },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            advanced_search: false,
            advanced_search_input: {},
            list_declarations: [],
            page: 1,
            last_page: 1,
            total_itens: 0,
            modalDisplayChangeStatus: 'none',
            ir: {
                id: '',
                status: ''
            }
        }
    },
    computed: {
        buttonPagination: function () {
            return this.page > 1;
        },
         validateSpdateStatus: function () {
            return this.ir.status != '';
        }
    },
    methods: {
        onCancel() { },
        advancedSearch() {
            this.advanced_search = !this.advanced_search
        },
        closeAdvancedSearch() {
            this.advanced_search = false
        },
        executeAdvancedSearch() {
            this.page = 1;
            this.list_declarations = {};
            this.loadData();
        },
        cleanAdvancedSearch() {
            this.list_declarations = {}
            this.advanced_search_input = {}
            this.loadData();
        },
        formatDecimal(number) {
            return new Intl.NumberFormat().format(number)
        },

        loadData() {
            this.isLoading = true;

            api.get('/ir', {
                params: {
                    'document': this.advanced_search_input.document,
                    'name': this.advanced_search_input.name,
                    'protocol': this.advanced_search_input.protocol,
                    'page': this.page
                }
            })
                .then((response) => {
                    this.isLoading = false;
                    this.total_itens = response.data.total_itens;
                    this.last_page = response.data.last_page;
                    if (this.page <= 1) {
                        this.list_declarations = response.data.data;
                    } else {
                        this.list_declarations = this.list_declarations.concat(response.data.data);
                    }

                    if (this.page < response.data.last_page) {
                        this.page++;
                    } else {
                        this.page = 1;
                    }

                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status);
                })
        },

        badgeStatus(status) {
            if (status == 'Pendente') {
                return 'badge-info';
            } else if (status == 'Finalizado') {
                return 'badge-success';
            } else if (status == 'Documentos Pendentes') {
                return 'badge-danger';
            }
            return 'badge-info';
        },

        openDetails(ir) {
            this.$router.push({ name: 'ir_detail', params: { id: ir.id } });
        },
        updateStatus(event){
           event.preventDefault();
           api.put('/ir/' + this.ir.id, { 'data': this.ir, 'type': 'update_status' })
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Status declaração atualizada com sucesso!",
                        type: 'success'
                    });
                    this.closeModalChangeStatus();
                    this.loadData();
                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status);
                })
        },

        showModalChangeStatus(ir) {
            this.ir.id = ir.id;
            this.modalDisplayChangeStatus = 'block';
        },

        closeModalChangeStatus() {
            this.modalDisplayChangeStatus = 'none';
        },

    },
    mounted() {
        this.loadData();
    },
}
</script>

<style></style>